import React from "react";

type Props = {
  image?: string;
  backgroundImage?: string;
  mobilebgImage?: string;
  heading?: string;
  description?: string;
  subDescription?: string;
  children?: string;
  ButtonclassName?: string;
  HeaderClassName?: string;
  descriptionClass?: string;
  className?: string;
  mainclassName?: string;
  whyYantrHead?: string;
  subwhyYantrHead?: string;
  buttonGroup?: any; // can pass button components
};

export default function MainPageHeader({
  image,
  backgroundImage,
  mobilebgImage,
  heading,
  description,
  subDescription,
  children,
  buttonGroup,
  ButtonclassName,
  HeaderClassName,
  descriptionClass,
  className,
  mainclassName,
  whyYantrHead,
  subwhyYantrHead,
}: Props) {
  return (
    <>
      {/* mobile view */}
      <div className="d-block d-md-none">
        <div
          style={{
            backgroundImage: `url(${mobilebgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            height: "100%",
            width: "100%",
          }}
          className={`whyyantraiheader pt-50 pb-20 ${mainclassName}`}
        >
          <div className={`container ${className}`}>
            <p
              className={`wp-61 line-46 fonts-300 font-40 my-20 main-heading font-family-condensed text-white-color plat-header ${HeaderClassName}`}
            >
              {heading}
            </p>
            <p
              className={`font-family-roboto wp-80 line-23 fonts-400 font-family-roboto font-20 text-white-color sub-heading ${descriptionClass}`}
            >
              {description}
            </p>
            <p
              className={`font-family-condensed line-28 wp-75 fonts-300 font-24 pt-10 text-white-color`}
            >
              {whyYantrHead}
            </p>
            <p
              className={`wp-100 fonts-300 font-16 line-18 text-white-color font-family-roboto pt-10`}
            >
              {subwhyYantrHead}
            </p>
            <p
              className={`font-family-roboto wp-80 fonts-400 font-20 sub-sub-heading ${descriptionClass}`}
            >
              {subDescription}
            </p>

            <div
              className={`buttongroup d-flex justify-content-start flex-gap-20 mt-14 wp-28 ${ButtonclassName}`}
            >
              {buttonGroup}
            </div>
          </div>
        </div>
      </div>
      {/* website view */}
      <div className="d-none d-md-block">
        <div
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            height: "400px",
            width: "100%",
          }}
          className={`whyyantraiheader pt-90 pb-50 ${mainclassName}`}
        >
          <div className={`container ${className}`}>
            <p
              className={`wp-53 line-46 fonts-300 width-media font-40 my-20 main-heading font-family-condensed text-white-color plat-header ${HeaderClassName}`}
            >
              {heading}
            </p>
            <p
              className={`font-family-roboto wp-63 width-media line-23 fonts-400 font-family-roboto font-20 text-white-color sub-heading plat-desc ${descriptionClass}`}
            >
              {description}
            </p>
            <p
              className={`wp-40 line-46 fonts-300 width-media font-40 my-20 main-heading font-family-condensed text-white-color plat-header ${HeaderClassName}`}
            >
              {whyYantrHead}
            </p>
            <p
              className={`font-family-roboto wp-45 width-media line-23 fonts-400 font-family-roboto font-20 text-white-color sub-heading plat-desc ${descriptionClass}`}
            >
              {subwhyYantrHead}
            </p>
            <p
              className={`font-family-roboto wp-63 width-media fonts-400 font-20 sub-sub-heading plat-desc ${descriptionClass}`}
            >
              {subDescription}
            </p>
            <div
              className={`buttongroup d-flex justify-content-start flex-gap-20 mt-24 wp-28 ${ButtonclassName}`}
            >
              {buttonGroup}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
